import { InjectionToken, NgModuleFactory, Type } from '@angular/core';

export type LazyModulesProvider = () => Promise<NgModuleFactory<any> | Type<any>>;
export const LAZY_MODULES = new InjectionToken<{ [key: string]: string }>('LAZY_MODULES');
